import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "report-details d-flex flex-column" }
const _hoisted_2 = { class: "report-details__header d-flex flex-column" }
const _hoisted_3 = { class: "top flex-row justify-content-between d-flex" }
const _hoisted_4 = { class: "left d-flex flex-row" }
const _hoisted_5 = { class: "head-inner-right" }
const _hoisted_6 = { class: "report-details__header__heading" }
const _hoisted_7 = { class: "report-details__header__type" }
const _hoisted_8 = { class: "right d-flex justify-content-end align-items-end" }
const _hoisted_9 = { class: "report-details__header__started" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, "Incident started: ", -1)
const _hoisted_11 = { class: "report-details__location d-flex flex-row justify-content-between" }
const _hoisted_12 = { class: "left d-flex flex-row align-items-center" }
const _hoisted_13 = { class: "location-inner-right d-flex flex-column justify-content-center" }
const _hoisted_14 = { class: "report-details__location__address" }
const _hoisted_15 = { class: "report-details__location__name" }
const _hoisted_16 = { class: "report-details__location__details d-flex justify-content-center align-items-center" }
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" View map ")
const _hoisted_19 = { class: "report-details__details d-flex flex-row" }
const _hoisted_20 = { class: "report-details__details-container row col-12 col-md-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h5", { class: "report-details__details__pfa-title details-title col-4" }, " PFA: ", -1)
const _hoisted_22 = { class: "report-details__details__pfa-info details-info col-8" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h5", { class: "report-details__details__pfa-title details-title col-4" }, " Zone: ", -1)
const _hoisted_24 = { class: "report-details__details__pfa-info details-info col-8" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h5", { class: "report-details__details__pfa-title details-title col-4" }, " Station: ", -1)
const _hoisted_26 = { class: "report-details__details__pfa-info details-info col-8" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h5", { class: "report-details__details__pfa-title details-title col-4" }, " Result: ", -1)
const _hoisted_28 = { class: "report-details__details__pfa-info details-info col-8" }
const _hoisted_29 = { class: "report-details__details-container row col-12 col-md-6" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h5", { class: "report-details__details__pfa-title details-title col-4" }, " Method: ", -1)
const _hoisted_31 = { class: "report-details__details__pfa-info details-info col-8" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h5", { class: "report-details__details__pfa-title details-title col-4" }, " 1st Caller: ", -1)
const _hoisted_33 = { class: "report-details__details__pfa-info details-info col-8" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("h5", { class: "report-details__details__pfa-title details-title col-4" }, " NZTM: ", -1)
const _hoisted_35 = { class: "report-details__details__pfa-info details-info col-4" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("strong", null, "E", -1)
const _hoisted_37 = { class: "report-details__details__pfa-info details-info col-4" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("strong", null, "N", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IncidentIcon = _resolveComponent("IncidentIcon")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_IncidentIcon, {
            type: _ctx.cadSummary.eventTypeCode,
            class: "icon"
          }, null, 8, ["type"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.fixCapitalization(_ctx.cadSummary.eventTypeDescription)), 1),
            _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.fixCapitalization(_ctx.cadSummary.incidentNoteText)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, [
            _hoisted_10,
            _createTextVNode(_toDisplayString(_ctx.formatDateThenTime(_ctx.cadSummary.addedTimestamp)), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_font_awesome_icon, {
          icon: "map-marker-alt",
          class: "report-details__location__icon"
        }),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.fixCapitalization(_ctx.cadSummary.addressCombinedText)), 1),
          _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.fixCapitalization(_ctx.cadSummary.premisesName)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("a", {
          class: "report-details__location__map-button",
          href: 
            _ctx.generateMapLink(
              _ctx.cadSummary.xCoordinateNumber,
              _ctx.cadSummary.yCoordinateNumber
            )
          
        }, [
          _hoisted_18,
          _createVNode(_component_font_awesome_icon, {
            icon: "external-link-alt",
            class: "report-details__location__map-icon"
          })
        ], 8, _hoisted_17)
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.cadSummary.alarmIdentifier ?? "-"), 1),
        _hoisted_23,
        _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.cadSummary.emergencyServicesZoneIdentifier ?? "-"), 1),
        _hoisted_25,
        _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.cadSummary.stationIdentifier ?? "-"), 1),
        _hoisted_27,
        _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.cadSummary.eventResultText ?? "-"), 1)
      ]),
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.cadSummary.callSourceCode ?? "-"), 1),
        _hoisted_32,
        _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.cadSummary.callerName ?? "-"), 1),
        _hoisted_34,
        _createElementVNode("p", _hoisted_35, [
          _hoisted_36,
          _createTextVNode(" " + _toDisplayString(_ctx.cadSummary.xCoordinateNumber ?? "-"), 1)
        ]),
        _createElementVNode("p", _hoisted_37, [
          _hoisted_38,
          _createTextVNode(" " + _toDisplayString(_ctx.cadSummary.yCoordinateNumber ?? "-"), 1)
        ])
      ])
    ])
  ]))
}